import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneGallery, updateGallery } from 'slice/gallerySlice';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const getImageUrl = (image) => {
  if (!image) return null;
  if (/^https?:\/\//i.test(image)) return image;

  const backendBase = (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, '');
  if (!backendBase) return image;

  const normalizedPath = String(image).replace(/^\/+/, '');
  const fullPath = normalizedPath.startsWith('uploads/')
    ? normalizedPath
    : `uploads/${normalizedPath}`;
  return `${backendBase}/${fullPath}`;
};

const UpdateGallery = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, data } = useSelector((state) => state.gallery);
  const [formData, setFormData] = useState({
    name: '',
    image: null,
    preview: null,
    is_active: 1
  });

  useEffect(() => {
    dispatch(getOneGallery(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (data && data.id !== undefined) {
      setFormData({
        name: data.name || '',
        image: null,
        preview: getImageUrl(data.image) || null,
        is_active: data.is_active ?? 1
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setFormData((prev) => ({
      ...prev,
      image: file,
      preview: URL.createObjectURL(file)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name.trim());
    formDataToSend.append('is_active', formData.is_active);
    if (formData.image) {
      formDataToSend.append('image', formData.image);
    }

    try {
      dispatch(updateGallery({ id: id, data: formDataToSend }));
      toast.success('Gallery image updated successfully');
      navigate('/gallery');
    } catch (error) {
      console.error('There was a problem updating the gallery image:', error.message);
      toast.error('Failed to update gallery image');
    }
  };

  return (
    <div className="container-fluid px-4 py-4">
      <div className="card shadow border-0">
        <div className="card-header bg-primary text-white py-3">
          <h5 className="mb-0">Update Gallery Image</h5>
        </div>
        <div className="card-body p-4">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label htmlFor="galleryName" className="adminlables">
                  Name
                </label>
                <input
                  type="text"
                  id="galleryName"
                  name="name"
                  value={formData.name}
                  className="form-control"
                  placeholder="e.g. MRI Scan Center"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 mb-4">
                <label className="adminlables" htmlFor="status">
                  Status
                </label>
                <select id="status" name="is_active" value={formData.is_active} className="form-control" onChange={handleChange}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
              <div className="col-md-6 mb-4">
                <label htmlFor="galleryImage" className="adminlables">
                  Image (Leave blank to keep current)
                </label>
                <input
                  type="file"
                  id="galleryImage"
                  name="image"
                  accept="image/*"
                  className="form-control btn-block filebg"
                  onChange={handleFile}
                />
              </div>
              <div className="col-md-6 mb-4">
                <p className="adminlables mb-1">Current Image</p>
                <div>
                  {formData.preview ? (
                    <img
                      src={formData.preview}
                      alt={formData.name || 'gallery'}
                      style={{ maxWidth: 260, borderRadius: 8, border: '1px solid #e2e8f0' }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  ) : (
                    <p className="text-muted mb-0">No image</p>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end gap-3 mt-4">
              <button type="button" className="btn btn-light px-4" onClick={() => navigate('/gallery')}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary px-5" disabled={loading}>
                {loading ? 'Updating...' : 'Update Image'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateGallery;
